// Copyright (c) 2022 by Move Closer

/**
 * Number of reviews shown to the user.
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const REVIEWS_MAX_SHOW_LENGTH: number = 6
